import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { InspectionService } from '../../../service/inspection/inspection.service';
import { Inspection } from '../../../class/inspection';

@Component({
  selector: 'app-inspection',
  templateUrl: './inspection.component.html',
  styleUrls: ['./inspection.component.scss']
})
export class InspectionComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoInspection: Inspection;
    public inspection: Inspection;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];

    constructor(
        public inspectionService: InspectionService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelInspection () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspections/inspection/inspection.component.ts